import React from "react";
import moment from "moment";
import { useNavigate } from "react-router";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Header from "../../../wizard/Header";
import WeightMismatchAlert from "../WeightMismatchAlert";
import Footer from "../../../wizard/Footer/Footer";
import useAuth from "../../../../hooks/useAuth";
import LabelingOptionsModal from "../../../modals/LabelingOptionsModal";
import PdfLinkActions from "../../../PdfLinkActions";
import useItemLabelsModal from "../../../../hooks/useItemLabelsModal";

export default function ScannedCompletedShipmentInfoStep({ project, shipment }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const itemLabelsModal = useItemLabelsModal();
  const { settings = {} } = user?.company || {};

  const completedOn = shipment?.completeTime;
  const startedOn = shipment?.startTime;
  const dateValue = completedOn || startedOn;
  const dateLabel = completedOn ? "Completed on" : "Started on";
  const dateDisplayValue = dateValue ? moment(dateValue).format("MM/DD/YYYY") : "";
  const completedByUser = shipment?.completedBy || shipment?.completer;
  const completedBy =
    completedByUser?.name ||
    completedByUser?.email ||
    shipment?.user?.name ||
    shipment?.user?.email ||
    "";
  const filterFieldName =
    shipment?.filter_field?.name ||
    shipment?.filterField?.name ||
    shipment?.project?.name ||
    project?.name ||
    "";
  const filterFieldLabel = `${settings?.filter_field2 || "Project"} Name`;
  const handleContinue = () => {
    const pathname = window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set("step", "shipment");
    params.delete("receivingSource");
    navigate({ pathname, search: params.toString() });
  };

  return (
    <>
      <Header title="Shipment Details" info={shipment?.shipmentId} />
      <WeightMismatchAlert shipment={shipment} />
      <Box
        p={2}
        minHeight={400}
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Grid container spacing={1.5}>
          <Grid size={12}>
            <TextField
              size="small"
              fullWidth
              disabled
              value={filterFieldName}
              label={filterFieldLabel}
            />
          </Grid>
          <Grid size={6}>
            <TextField size="small" fullWidth disabled value={dateDisplayValue} label={dateLabel} />
          </Grid>
          <Grid size={6}>
            <TextField size="small" fullWidth disabled value={completedBy} label="Completed by" />
          </Grid>
          <Grid size={6}>
            <PdfLinkActions
              resourceType="shipment_pdfs"
              resourceId={shipment?.id}
              label="Shipment PDF"
              color="primary"
              fullWidth
            />
          </Grid>
          <Grid size={6}>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              onClick={() => itemLabelsModal.openForShipment(shipment?.id)}
            >
              Shipment Item PDF
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box mt={2}>
        <Footer step={0} startTime={startedOn} completeTime={completedOn}>
          <Button variant="contained" onClick={handleContinue}>
            Continue
          </Button>
        </Footer>
      </Box>
      {itemLabelsModal.isOpen && itemLabelsModal.shipmentId === shipment?.id && (
        <LabelingOptionsModal
          onClose={itemLabelsModal.close}
          shipmentId={shipment?.id}
          project={project || shipment?.project}
        />
      )}
    </>
  );
}
